/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_Legal_DescInputs */

const es_privacy_policy_sharing_legal_desc = /** @type {(inputs: Privacy_Policy_Sharing_Legal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podemos divulgar informacion cuando sea requerido por ley, proceso judicial valido, o para proteger la seguridad personal de nuestros usuarios.`)
};

const en_privacy_policy_sharing_legal_desc = /** @type {(inputs: Privacy_Policy_Sharing_Legal_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We may disclose information when required by law, valid judicial process, or to protect the personal safety of our users.`)
};

/**
* | output |
* | --- |
* | "We may disclose information when required by law, valid judicial process, or to protect the personal safety of our users." |
*
* @param {Privacy_Policy_Sharing_Legal_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_legal_desc = /** @type {((inputs?: Privacy_Policy_Sharing_Legal_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_Legal_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_legal_desc(inputs)
	return en_privacy_policy_sharing_legal_desc(inputs)
});
export { privacy_policy_sharing_legal_desc as "privacy_policy.sharing.legal_desc" }